module.exports = __webpack_public_path__ + "img/index2.3610c867.jpg";